// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSavePriceStyles } from "@awc/App/Components/Product/ProductSavePrice";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, getSystemColor } from "@awc/XDL/Utilities";
import { css } from "styled-components";

productSavePriceStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-bottom: 10px;
    `,
};

productSavePriceStyles.realtimePrice = {
    color: "secondary",
    size: fontConfig.fontSize.link,
    lineHeight: fontConfig.lineHeight.small,
    weight: fontConfig.weight.bold,
    css: css`
        display: block;
        margin-bottom: 5px;
    `,
};

productSavePriceStyles.savePrice = {
    color: getSystemColor("common.white"),
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.small,
    css: css`
        background-color: ${color("common.ui12")};
        display: block;
        padding: 4px 8px;
    `,
};
productSavePriceStyles.originalPrice = {
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.small,
    weight: fontConfig.weight.bold,
    css: css`
        display: block;
        margin-top: 5px;
    `,
};
